import React from 'react';
import { useParams } from 'react-router-dom';
import { useFetch, useApiClient } from '@marageti/z4-lib';
import { Alert, AlertTitle, Box } from '@mui/material';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import Conversation from './conversations';
import TripRequestSubNavigation from '../../../components/trip-request-sub-navigation';

const MessagesContainer = () => {
  const { tripRequestId } = useParams();
  const apiClient = useApiClient();
  const { data: tripRequest, error } = useFetch<TripRequest>(apiClient.tripRequestsClient.getTripRequest, [tripRequestId], true);

  if (error) {
    return (
      <Box sx={{ my: 3 }}>
        <Alert severity="error" sx={{ py: 2 }}>
          <AlertTitle>An error occurred</AlertTitle>
          {`Code: ${error.code}: ${error.message}`}
          {error.id && `ID: ${error.id}`}
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <TripRequestSubNavigation tripRequest={tripRequest} />
      <Conversation
        conversationId={tripRequest?.travelerToZicassoId}
        conversationTitle="Zicasso Care Specialist"
      />
    </>
  );
};

export default MessagesContainer;
